// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__trqoF","name":"styles_name__3aWCz","phone":"styles_phone__2Mxne"};